import React, { useEffect, useRef } from "react";

export default function MobileBottomAd() {
    const adRef = useRef(null);
    const loadedRef = useRef(false);

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (
                adRef.current &&
                adRef.current.offsetWidth > 0 &&
                !loadedRef.current
            ) {
                try {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                    loadedRef.current = true;
                } catch (e) {
                    console.error("Adsense Error", e);
                }
            }
        });

        if (adRef.current) observer.observe(adRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="fixed bottom-0 left-0 w-full p-2 shadow-lg block md:hidden z-50 bg-black/10 backdrop-blur-sm">
            <div className="flex justify-center">
                <ins
                    className="adsbygoogle"
                    ref={adRef}
                    style={{ display: "block" }}
                    data-ad-client="ca-pub-6063063628146000"
                    data-ad-slot="9987577751"
                    data-ad-format="auto"
                    data-full-width-responsive="true"
                ></ins>
            </div>
        </div>
    );
}
